/**
 * @generated SignedSource<<be6e4a64670eb8c910e61f9369b0d0d7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEtherConversion_etherRates$data = ReadonlyArray<{
  readonly currency: string | null;
  readonly rate: number | null;
  readonly " $fragmentType": "useEtherConversion_etherRates";
}>;
export type useEtherConversion_etherRates$key = ReadonlyArray<{
  readonly " $data"?: useEtherConversion_etherRates$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useEtherConversion_etherRates",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    }
  ],
  "type": "EtherRates",
  "abstractKey": null
};

(node as any).hash = "58248fbde6af0baeaea0dceb857f97f4";

export default node;
